<template>
  <div>
    <!--搜索-->
    <div class="search-wrapper">
      <el-form :inline="true" size="mini" label-width="70px" :model="searchForm" :rules="rules" ref="searchForm">
        <div class="search-row">
          <el-form-item label="文件名:" prop="employeeNo">
            <el-input v-model.trim="searchForm.fileName" placeholder="请输入文件名"></el-input>
          </el-form-item>

          <el-form-item style="float: right;">
            <el-button class="green-btn" @click="onSearchList">搜索</el-button>
            <el-button class="orange-btn" @click="resetForm">重置</el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>

    <!--列表-->
    <el-container class="list-wrapper">
      <el-main class="table-wrap">
        <div style="margin: 10px 0;">
          <el-button
            type="primary"
            size="mini"
            class="green-btn"
            @click="upload"
          >上传
          </el-button>
          <el-button
            type="primary"
            size="mini"
            class="green-btn"
            @click="bacthoPeration(1)"
          >下载
          </el-button>
          <el-button
            type="warning"
            size="mini"
            @click="bacthoPeration"
          >删除
          </el-button>
        </div>
        <el-table
          @select="serlectRow"
          ref="table"
          :height="tableHeight"
          border
          :data="tableData.records"
          :header-cell-style="{backgroundColor: '#F4F8FB',textAlign: 'center'}"
          :cell-style="{textAlign: 'center'}"
          style="width: 100%"
          v-loading="loading"
          @sort-change="handleSortChange"
          @selection-change="handleSelectionChange"
          :row-key="
            (row) => {
              return row.dataId;
            }
          "
          element-loading-text="数据加载中..."
          element-loading-spinner="el-icon-loading"
        >
          <el-table-column type="selection" width="55" :reserve-selection="true"></el-table-column>
          <el-table-column :show-overflow-tooltip='true' prop="productCode" label="商品编码"></el-table-column>
          <el-table-column :show-overflow-tooltip='true' prop="productName" label="商品名称"></el-table-column>
          <el-table-column :show-overflow-tooltip='true' prop="fileName" width="380" label="文件名" sortable>
            <template slot-scope="scope" >
                <template v-if="scope.row.videoFlag == 'Y'">
                  <el-link
                  :underline="false"
                  type="primary"
                  @click="videoShow(scope.row)"
                  >{{ scope.row.fileName }}</el-link
                >
                </template>
                <template v-else>{{ scope.row.fileName }}</template>
            </template>
          </el-table-column>
          <el-table-column :show-overflow-tooltip='true' prop="creationDate" label="上传时间" sortable></el-table-column>
          <el-table-column :show-overflow-tooltip='true' prop="createdBy" label="上传人"></el-table-column>
          <el-table-column :show-overflow-tooltip='true' prop="fileExt" label="类型"></el-table-column>
          <el-table-column :show-overflow-tooltip='true' prop="fileSize" label="大小"></el-table-column>
          <el-table-column label="操作" width="140">
            <template slot-scope="scope">
              <el-button type="text" @click="downLoadRequest(scope.row.filePath, scope.row.fileName)">下载</el-button>
              <el-button type="text" @click="edit(scope.row)">修改</el-button>
              <el-button type="text" @click="del(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-main>
      <el-footer height="auto" style="text-align: right;padding:5px 0;">
        <el-pagination
          @size-change="onSizeChange"
          @current-change="onCurrentChange"
          :current-page="tableData.pageNum"
          :page-sizes="[30, 100, 500, 1000]"
          :page-size="tableData.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="tableData.total"
        ></el-pagination>
      </el-footer>
    </el-container>
    <!-- 查看图片弹窗 -->
    <el-dialog
      title="视频查看"
      :visible.sync="imgFormVisible"
      :close-on-click-modal="false"
      width="50%"
      v-esc-close
      ><imgShow :imgList="imgList"></imgShow
    ></el-dialog>
    <!--新增/编辑弹框-->
    <el-dialog
      :visible.sync="editDialogVisible"
      title="修改文件名"
      width="500px"
      @close="closeAddForm"
    >
      <el-form
        ref="addForm"
        :model="editForm"
        label-width="70px"
        style="height: 100px"
        :rules="rules"
      >
        <el-form-item label="文件名:" prop="fileName">
          <el-input  type="textarea" :autosize="{ minRows: 2, maxRows: 4}" v-model.trim="editForm.fileName" size="small"></el-input>
        </el-form-item> 
      </el-form>
      <div slot="footer" style="text-align: right">
        <el-button @click="closeAddForm">取消</el-button>
        <el-button type="primary" @click="editConfirm"> 确认 </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import pagePathMixin from '@/utils/page-path-mixin'
import imgShow from "./imgShow";
import moment from 'moment'
  export default {
    name: 'fileManagement',
    mixins: [pagePathMixin],
    components: { imgShow },
    data() {
      return {
        tableHeight: null,
        loading:true,
         titleName: '',
        showFlag: false,
        searchForm: {
        },
        rules: {
        },
        requestParam: {},
        imgFormVisible: false,
        imgList: [],
        tableData: {
          records: [],
          pageNum: 1,
          pageSize: 30,
          total: 0
        },
        model: [],
        maxHeight: 'auto',
        params: {
          headers: {
            'Content-Type': 'application/json;charset=utf-8' // 根据后台的接参数方式前端指定请求头
          }
        },
        radio: null,
        selectSpus: [],
        onRemoveSpuIds: [],
        foldId: '',
        fliePath: '',
        errorNum: 0,
        editDialogVisible: false,
        editForm: {},
        tableRow: {},
        sortParams: {}
      };
    },
    computed: {
    },
    methods: {
      serlectRow(i, v) {
        this.model = i;
      },
      handleSelectionChange(val) {
        this.onRemoveSpuIds = [];
        console.log("val", val);
        val.forEach((x) => {
          this.onRemoveSpuIds.push(x.id);
        });
        this.selectSpus = val;
      },
      closeAddForm() {
        this.editDialogVisible = false
      },
      edit(row) {
        console.log(row);
        this.tableRow = row
        this.$set(this.editForm,'fileName',row.fileName)
        this.editDialogVisible = true
        
      },
      editConfirm() {
        console.log(this.editForm.fileName);
        let data  = {
          folderId: this.tableRow.dataId,
          folderName: this.editForm.fileName,
          type: 1
        }
        this.$q.shortVideoOverview.updateFileName({data:data}).then((res) => {
          if(res.code == 200) {
            this.$message.success('修改成功')
            this.editDialogVisible = false
            this.onSearch();
          }
        })
      },
      onSearch(foldId) {
        this.foldId = foldId || this.foldId
        this.loading = true;
        let param = {
          pageNum:this.tableData.pageNum,
          pageSize:this.tableData.pageSize,
          foldId: foldId || this.foldId,
          ...this.searchForm,
          ...this.sortParams
        }
        this.$q.shortVideoOverview.videoFiles({data: JSON.stringify(param)}).then((res) => {
          this.tableData = res.data;
          if (res.code == 200){
            this.loading = false;
          }

        });
      },
      videoShow(row) {
        this.imgFormVisible = true
        this.imgList = []
        this.imgList.push(row.filePath)
      },
      resetTableSort() {
        this.$refs.table.clearSort()
      },
      onSearchList(){
        this.tableData.pageSize = 30;
        this.tableData.pageNum = 1;
        if(this.$refs.table) {
          this.$refs.table.clearSelection(); 
          this.$refs.table.clearSort()
        }
        this.onSearch();
      },
      resetForm() {
        this.initSearchForm();
        this.onSearchList()
      },
      initSearchForm() {
        this.searchForm = {
        }
      },
      onSizeChange(pageSize) {
        this.tableData.pageNum = 1;
        this.tableData.pageSize = pageSize;
        this.loading=true;
        this.onSearch();
      },
      onCurrentChange(pageNum) {
        this.tableData.pageNum = pageNum;
        this.loading=true;
        this.onSearch();
      },
      getCaption(obj) {
        var index = obj.lastIndexOf("."); //获取-后边的字符串
        obj = obj.substring(index + 1, obj.length);
        return obj;
      },
      downLoadRequest(filePath, fileName) {
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        setTimeout(_=>{
          this.downLoad(filePath, fileName)
          loading.close();
        },300)
      },
      downLoad(path, name) {
        console.log(999);
        let this_ = this
        let url = path;
        let fileName = name;
        fetch(
        path,
        { method: "GET", mode: "cors" }
      ).then(res => res.blob().then(blob=>{
        // debugger;
        console.log(blob);
        var link = document.createElement("a");
        var body = document.querySelector("body");

        link.href = window.URL.createObjectURL(blob);
        link.download = fileName+ '.' + this_.getCaption(path);

        // fix Firefox
        link.style.display = "none";
        body.appendChild(link);

        link.click();
        body.removeChild(link);
        window.URL.revokeObjectURL(link.href);
        this.errorNum = 0
      })).catch(err=>{
        this.errorNum += 1
        if(this.errorNum > 10) return
        setTimeout(() => {
          this.downLoad(path,name)
        }, 1000);
      })
        // var xhr = new XMLHttpRequest();
        // xhr.open("GET",url, true);
        // xhr.responseType = "blob";
        // xhr.onload = function() {
        //   if (xhr.status === 200) {
        //     if (window.navigator.msSaveOrOpenBlob) {
        //       navigator.msSaveBlob(xhr.response, fileName);
        //     } else {
        //       var link = document.createElement("a");
        //       var body = document.querySelector("body");
        //       link.href = window.URL.createObjectURL(xhr.response);
        //       link.download = fileName+ '.' + this_.getCaption(path);

        //       // fix Firefox
        //       link.style.display = "none";
        //       body.appendChild(link);
        //       link.click();
        //       body.removeChild(link);
        //       window.URL.revokeObjectURL(link.href);
        //     }
        //   }
        // };
        // xhr.send();
      },
      upload() {
        this.openSubPage({
          path: '/shortVideoUpload',
          query: {
            foldId: this.foldId,
            fliePath: this.fliePath
          }
        })
      },
     async bacthoPeration(type) {
        if(!this.selectSpus.length){
          this.$message.error('请选择后在进行操作')
          return
        }
        if(type == 1) { //下载
          if(this.selectSpus.length > 1) {
            const loading = this.$loading({
              lock: true,
              text: 'Loading',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            });
            let data = this.selectSpus.map(v=>v.dataId)
            this.$q.shortVideoOverview
            .downloadFiles({data: data, options: {responseType: 'blob'}})
            .then((res) => {
              if(res.size < 100) {
                this.$message.error('文件不能大于300m')
                loading.close()
                return
              }
              let fileName = '短视频'+moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
              this.blobDownload( res, `${fileName}.zip`);
              loading.close()
              this.$message.success('下载成功')
            })
          }else {
            this.downLoadRequest(this.selectSpus[0].filePath,this.selectSpus[0].fileName)
          }
          // this.selectSpus.forEach((item,index) => {
          //   // this.downLoadRequest(item.filePath, item.fileName)
          //   // console.log(filePath,fileName);
          //   // const loading = this.$loading({
          //   //   lock: true,
          //   //   text: 'Loading',
          //   //   spinner: 'el-icon-loading',
          //   //   background: 'rgba(0, 0, 0, 0.7)'
          //   // });
          //   setTimeout(_=>{
          //     this.downLoad(item.filePath, item.fileName)
          //     // loading.close();
          //   },1000*index)
          // })
        }else { //删除
          let status = await this.$confirm("确认删除当前文件？")
          if (status !== "confirm") return
          const fileIds = this.selectSpus.map(v => v.dataId)
          this.$q.shortVideoOverview.videoFilesDelBatch({ data: { fileIds } }).then((res) => {
            if (res.code == 200){
              this.$message.success('删除成功')
              this.onSearchList()
            }
          });
        }
        
      },
     async del(row) {
        let status = await this.$confirm("确认删除当前文件？")
        if (status !== "confirm") return
        this.$q.shortVideoOverview.videoFilesDel({fragment: [row.dataId]}).then((res) => {
          if (res.code == 200){
            this.$message.success('删除成功')
            this.onSearchList()
          }
        });
      },
      handleSortChange({prop, order}) {
        this.sortParams = {
          sortOptions: order == 'ascending' ? 0 : order == 'descending' ? 1 : '',
          sortField: prop
        }
        this.tableData.pageNum = 1;
        this.onSearch()
      },
      formatJson(filterVal, jsonData) {
        return jsonData.map(v => filterVal.map(j => v[j]))
      },
    },

    mounted() {
      this.tableHeight = window.innerHeight - 220;
      // this.onSearch();
    },
    
  }
</script>

<style lang="stylus" scoped>
  .search-wrapper
    margin 0px 2px 6px 2px
    padding 10px
    border-radius: 4px
    background-color #ffffff

  >>> .el-form-item
    margin-bottom 0 !important

  >>> .el-divider
    margin 5px 0

  >>> .el-main {
    padding: 0 5px !important
  }

  .list-wrapper
    margin 2px 2px 4px 2px
    border-radius: 4px
    background-color #ffffff

  .table-wrap
    padding 10px
</style>
